import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    to {
        transform: rotate(360deg)
    }
`;

export const Loader = styled.div`
    height: calc(100vh - 340px);
    display: flex;
    align-items: center;
    justify-content: center;

    .logo {
        width: 40px;
        padding: 29px 42px;
        box-sizing: content-box;
        position: relative;

        &::after,
        &::before {
            content: '';
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
            border-radius: 100%;
        }

        &::before {
            border: 1px solid lightgray;
        }

        &::after {
            -webkit-mask-image: -webkit-linear-gradient(bottom, transparent 70%, #5062CD);
            mask-image: linear-gradient(bottom, transparent 70%, #5062CD);
            padding: 1px;
            box-shadow: inset 0 0 0 1px var(--primary);
            transform: rotate(0);
            animation: ${spin} 1.5s linear infinite;
        }
        
        img {
            margin-top: 12px;
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
`;

